import * as navigation from 'Navigation';

export default class ProcedureTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Procedure',
      closeable: false,
      preferenceKey: 'procedure',
    };
  }
}
